import React from 'react';

function Logo(props) {
    return (
        <img src={process.env.PUBLIC_URL + '/img/logo.png'} alt="logo" {...props}/>
    );
}

export default Logo;